import AirportShuttle from "@mui/icons-material/AirportShuttle";

import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useState } from "react";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { MenuDropdown } from "../../../common-components/MenuDropdown/MenuDropdown";
import { MenuLink } from "../../../common-components/MenuLink/MenuLink";


const VehiclesLinks = ({ onClose }) => {
    const [isMobile, setIsMobile] = useState();
    const { pathname } = useLocation();

    const data = useSelector((state) => state.user.data);
    const permissions = data?.attributes?.role_id;
    const companyKey = data?.attributes?.rescue_company_id;

    const hasPermission = companyKey === "РЦШ ПВАСС" && (permissions === "admin" || permissions === "central_office_user");

    useEffect(() => {
        const checkIsMobile = () => setIsMobile(window.innerWidth <= 1024);
        checkIsMobile();
        window.addEventListener("resize", checkIsMobile);
        return () => window.removeEventListener("resize", checkIsMobile);
    }, []);

    const rawLinks = useMemo(
        () => [
            { title: "Транспорт", active: true, show: true, link: "/Vehicles" },
            { title: "Статистика", active: true, show: true, link: "/TransportStatistic" },
        ],
        [hasPermission]
    );

    const preparedLinks = rawLinks
        .map((link) => {
            if (isMobile && link.link === "/StatisticPage") {
                return { ...link, active: false };
            }
            return link;
        })
        .filter((link) => link.show);

    const links = preparedLinks.map((link) => {
        const isCurrent =
            pathname === link.link || pathname.startsWith(link.link + "/");

        const wrapperClass =
            "menu-link-wrap" +
            (isCurrent ? " _current" : "") +
            (!link.active ? " _disabled" : "");

        const handleNavigate = () => {
            onClose && onClose();
        };

        return (
            <div key={link.link} className={wrapperClass}>
                <MenuLink
                    title={link.title}
                    active={link.active}
                    show={link.show}
                    link={link.link}
                    onNavigate={handleNavigate}
                />
            </div>
        );
    });

    return (
        <>
            <style>{`
        .menu-link-wrap { position: relative; border-radius: 7px; padding: 0 7px}
        .menu-link-wrap._current {
          background-color: #ecf3ff;
        }
        .menu-link-wrap._disabled { opacity: 0.5; }
      `}</style>

            <MenuDropdown
                Icon={AirportShuttle}
                title={"Транспорт"}
                active={true}
                links={links}
            />
        </>
    );
};

export default VehiclesLinks;